export default __webpack_public_path__ + "static/media/arrowLeft.5cbd6dfa.svg";